import * as React from 'react';

export function useDebounce<TArgs extends any[], TReturn>(
  fn: (...args: TArgs) => TReturn,
  time?: number,
): (...args: TArgs) => TReturn extends Promise<any> ? TReturn : Promise<TReturn>;
export function useDebounce<TArgs extends any[], TReturn>(
  fn: (...args: TArgs) => TReturn,
  time = 500,
): (...args: TArgs) => Promise<TReturn> {
  const timerRef = React.useRef<number>(undefined);
  const promiseRef = React.useRef<Promise<TReturn>>(undefined);
  const resolveRef = React.useRef<(value: TReturn) => void>(undefined);
  return React.useCallback(
    (...args: TArgs) => {
      if (!promiseRef.current) {
        promiseRef.current = new Promise(resolve => (resolveRef.current = resolve));
      }

      window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => {
        resolveRef.current!(fn(...args));

        promiseRef.current = undefined;
        resolveRef.current = undefined;
      }, time);

      return promiseRef.current;
    },
    [fn, time],
  );
}
